import nuvamaLogo from "../../assets/images/svg/nuvama_logo.svg";
import fastForwardIcon from "../../assets/images/svg/fastForwardIcon.svg";
import whiteDot from "../../assets/images/svg/whiteDot.svg";
import Modal from "../Modal";
import FooterModal from "../../pages/Home/FooterModal";
import { useRef, useState } from "react";
import { useLocation } from "react-router";
import { observer } from "mobx-react";
import SettingsStore from "../../store/SettingsStore";
import { getDecodedToken } from "../../utils/functions";
import {
  buildDetails,
  homePageRoute,
  logoAriaLabel,
} from "../../utils/constants";
import { Link } from "react-router-dom";

const Footer = observer(() => {
  const modalRef = useRef();
  const [rangeValue, setRangeValue] = useState("0");
  const [feedbackText, setFeedbackText] = useState("");
  const [feedbackModal, setFeedbackModal] = useState(false);
  const [step, setStep] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const location = useLocation();

  const handleFeedbackModal = () => {
    setFeedbackModal(!feedbackModal);
    setStep(0);
    setFeedbackText("");
    setRangeValue("0");
    setSubmitted(false);
  };

  return (
    <footer className="primary_bg_footer">
      <div className="footer_container">
        <div className="logo_email_container">
          <div className="logo_wrapper">
            <img src={nuvamaLogo} alt={`${logoAriaLabel} logo`} />
          </div>
          <div className="email_wrapper">
            <div className="email_icon_wrapper">
              <svg
                width="26"
                height="21"
                viewBox="0 0 26 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.5636 0.290039H2.92076C2.21036 0.290039 1.52905 0.553431 1.02672 1.02227C0.524393 1.49111 0.242188 2.127 0.242188 2.79004V17.79C0.242188 18.4531 0.524393 19.089 1.02672 19.5578C1.52905 20.0266 2.21036 20.29 2.92076 20.29H22.5636C23.274 20.29 23.9553 20.0266 24.4577 19.5578C24.96 19.089 25.2422 18.4531 25.2422 17.79V2.79004C25.2422 2.127 24.96 1.49111 24.4577 1.02227C23.9553 0.553431 23.274 0.290039 22.5636 0.290039ZM2.0279 2.79004C2.0279 2.56903 2.12197 2.35706 2.28941 2.20078C2.45686 2.0445 2.68396 1.95671 2.92076 1.95671H22.5636C22.8004 1.95671 23.0275 2.0445 23.195 2.20078C23.3624 2.35706 23.4565 2.56903 23.4565 2.79004V4.79004L14.01 9.54004C13.6203 9.73552 13.1847 9.83783 12.7422 9.83783C12.2997 9.83783 11.8641 9.73552 11.4743 9.54004L2.0279 4.79004V2.79004ZM22.5636 18.6234H2.92076C2.68396 18.6234 2.45686 18.5356 2.28941 18.3793C2.12197 18.223 2.0279 18.0111 2.0279 17.79V6.68171L10.6261 11.0067C11.2765 11.3335 12.0036 11.5045 12.7422 11.5045C13.4808 11.5045 14.2079 11.3335 14.8583 11.0067L23.4565 6.68171V17.79C23.4565 18.0111 23.3624 18.223 23.195 18.3793C23.0275 18.5356 22.8004 18.6234 22.5636 18.6234Z"
                  fill="#DDE2EB"
                />
              </svg>
            </div>
            <p className="email_text">
              <a
                style={{ color: "inherit", textDecoration: "none" }}
                href="mailto:info.nuvamaprivate@nuvama.com"
              >
                info.nuvamaprivate@nuvama.com
              </a>
            </p>
          </div>
        </div>
        <div className="footer_navigation_card_wrapper">
          <div className="footer_navigation_container">
            <button
              className="navigation_wrapper navigation-button"
              onClick={() => {
                if (location.pathname === `/${homePageRoute}`) {
                  window.scroll(0, 0);
                }
              }}
            >
              <div className="navigation_tab">
                <div className="menu_image_wrapper">
                  <svg
                    width="15"
                    height="16"
                    viewBox="0 0 15 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.9828 14.3766V12.0765C4.98279 11.4936 5.45675 11.0201 6.04383 11.0164H8.19946C8.78915 11.0164 9.2672 11.491 9.2672 12.0765V14.37C9.26719 14.8755 9.67801 15.2864 10.1872 15.29H11.6579C12.3447 15.2918 13.0041 15.0221 13.4904 14.5406C13.9767 14.059 14.25 13.4051 14.25 12.7232V6.18942C14.25 5.63858 14.004 5.11607 13.5785 4.76266L8.58223 0.79574C7.70888 0.101881 6.46153 0.124295 5.61404 0.849077L0.725259 4.76266C0.279555 5.10566 0.0131642 5.62971 0 6.18942V12.7165C0 14.1378 1.16054 15.29 2.59213 15.29H4.02922C4.27438 15.2918 4.51011 15.1963 4.6841 15.0249C4.85809 14.8534 4.95594 14.62 4.95594 14.3766H4.9828Z"
                      fill="#A8B1C1"
                    />
                  </svg>
                </div>
                <p>Home</p>
              </div>
            </button>
            <Link
              to="/reports/transactions-report"
              className="navigation_wrapper navigation-button"
            >
              <div className="navigation_tab">
                <div className="menu_image_wrapper">
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.0934 12.7141L18.0934 12.7141L18.0908 12.7114C17.9198 12.5401 17.6792 12.4322 17.4192 12.4322C16.8995 12.4322 16.4691 12.8571 16.4691 13.3839V16.4807H2.06393V13.3839C2.06393 13.1236 1.95631 12.8827 1.78533 12.7114C1.61435 12.5401 1.37381 12.4322 1.1138 12.4322C0.594073 12.4322 0.163672 12.8571 0.163672 13.3839V17.3757L0.163671 17.3797C0.163663 17.4323 0.163655 17.4854 0.176218 17.5451C0.229423 18.0183 0.6329 18.39 1.11948 18.39L17.4022 18.3902C17.8586 18.3902 18.2435 18.0608 18.3328 17.6251C18.351 17.5512 18.3636 17.4699 18.3636 17.3816V13.4602L18.3637 13.4601V13.3898C18.3637 13.1294 18.2561 12.8899 18.0934 12.7141Z"
                      fill="#A8B1C1"
                      stroke="#A8B1C1"
                      stroke-width="0.2"
                    />
                    <path
                      d="M14.1642 9.3919L9.98721 13.5766C9.98151 13.588 9.97013 13.5937 9.96459 13.5993C9.81152 13.7526 9.61322 13.8491 9.41493 13.8775C9.39785 13.8775 9.38093 13.8832 9.36385 13.8832C9.32985 13.8889 9.29585 13.8889 9.26185 13.8889L9.16555 13.8832C9.14847 13.8832 9.13155 13.8775 9.11447 13.8775C8.91048 13.8491 8.71772 13.7526 8.56481 13.5993C8.55911 13.5936 8.54773 13.5822 8.54219 13.5766L4.36524 9.3919C4.17247 9.19878 4.07617 8.94337 4.07617 8.68786C4.07617 8.43231 4.17247 8.17675 4.36524 7.98382C4.75061 7.59773 5.37968 7.59773 5.77074 7.98382L8.28145 10.4992L8.28129 1.2837C8.28129 0.738566 8.72898 0.290039 9.2731 0.290039C9.5451 0.290039 9.79447 0.403633 9.97583 0.579645C10.1572 0.761363 10.2649 1.0055 10.2649 1.28368V10.4992L12.7756 7.9838C13.161 7.59771 13.7901 7.59771 14.1811 7.9838C14.5496 8.3756 14.5496 9.00581 14.1642 9.39192L14.1642 9.3919Z"
                      fill="#DDE2EB"
                    />
                  </svg>
                </div>
                <p>Reports</p>
              </div>
            </Link>
            <Link
              className="navigation_wrapper navigation-button"
              to="/portfolio"
            >
              <div className="navigation_tab">
                <div className="menu_image_wrapper">
                  <svg
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      opacity="0.4"
                      d="M1.5 8.59473C1.5375 10.3482 1.6425 13.3475 1.6575 13.6782C1.71075 14.3855 1.9815 15.1002 2.403 15.6042C2.9895 16.3115 3.71175 16.6272 4.719 16.6272C6.111 16.6347 7.6455 16.6347 9.13575 16.6347C10.632 16.6347 12.084 16.6347 13.3103 16.6272C14.3033 16.6272 15.048 16.3032 15.627 15.6042C16.0485 15.1002 16.3193 14.378 16.3575 13.6782C16.3725 13.4 16.4475 10.1442 16.4925 8.59473H1.5Z"
                      fill="#A8B1C1"
                    />
                    <path
                      d="M8.43359 11.8291V12.7996C8.43359 13.1101 8.68559 13.3621 8.99609 13.3621C9.30659 13.3621 9.55859 13.1101 9.55859 12.7996V11.8291C9.55859 11.5186 9.30659 11.2666 8.99609 11.2666C8.68559 11.2666 8.43359 11.5186 8.43359 11.8291Z"
                      fill="#A8B1C1"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.65825 11.207C7.58325 11.4793 7.3215 11.6533 7.038 11.6158C5.12475 11.3488 3.29625 10.67 1.75275 9.65079C1.5945 9.54729 1.5 9.37029 1.5 9.18129V6.58179C1.5 5.00679 2.784 3.72579 4.36275 3.72579H5.838C5.979 2.63679 6.9015 1.79004 8.028 1.79004H9.9645C11.0902 1.79004 12.0135 2.63679 12.1545 3.72579H13.6372C15.2115 3.72579 16.4925 5.00679 16.4925 6.58179V9.18129C16.4925 9.37029 16.3972 9.54654 16.2405 9.65079C14.694 10.6745 12.858 11.3563 10.932 11.6225C10.9057 11.6263 10.8802 11.6278 10.8547 11.6278C10.6005 11.6278 10.3732 11.456 10.3095 11.204C10.158 10.607 9.61575 10.1893 8.9925 10.1893C8.361 10.1893 7.82475 10.598 7.65825 11.207ZM9.96531 2.91504H8.02881C7.52406 2.91504 7.10256 3.26004 6.97656 3.72579H11.0168C10.8908 3.26004 10.4693 2.91504 9.96531 2.91504Z"
                      fill="#A8B1C1"
                    />
                  </svg>
                </div>
                <p>Portfolio</p>
              </div>
            </Link>
            <Link
              className="navigation_wrapper navigation-button"
              to="/analytics"
            >
              <div className="navigation_tab">
                <div className="menu_image_wrapper">
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.3906 7.88232V0.00732422C11.457 0.00732422 12.4766 0.215332 13.4492 0.631348C14.4219 1.04736 15.2598 1.60693 15.9629 2.31006C16.666 3.01318 17.2256 3.85107 17.6416 4.82373C18.0576 5.79639 18.2656 6.81592 18.2656 7.88232H10.3906ZM8.14063 18.0073C7.07422 18.0073 6.05469 17.7993 5.08203 17.3833C4.10938 16.9673 3.27148 16.4077 2.56836 15.7046C1.86523 15.0015 1.30566 14.1636 0.889648 13.1909C0.473633 12.2183 0.265625 11.1987 0.265625 10.1323C0.265625 9.06592 0.473633 8.04639 0.889648 7.07373C1.30566 6.10107 1.86523 5.26318 2.56836 4.56006C3.27148 3.85693 4.10938 3.29736 5.08203 2.88135C6.05469 2.46533 7.07422 2.25732 8.14063 2.25732V10.1323H16.0156C16.0156 11.1987 15.8076 12.2183 15.3916 13.1909C14.9756 14.1636 14.416 15.0015 13.7129 15.7046C13.0098 16.4077 12.1719 16.9673 11.1992 17.3833C10.2266 17.7993 9.20703 18.0073 8.14063 18.0073Z"
                      fill="#A8B1C1"
                    />
                    <path
                      d="M10.3906 7.88232V0.00732422C11.457 0.00732422 12.4766 0.215332 13.4492 0.631348C14.4219 1.04736 15.2598 1.60693 15.9629 2.31006C16.666 3.01318 17.2256 3.85107 17.6416 4.82373C18.0576 5.79639 18.2656 6.81592 18.2656 7.88232H10.3906Z"
                      fill="#DDE2EB"
                    />
                  </svg>
                </div>
                <p>Analytics</p>
              </div>
            </Link>
            <Link
              to="/performance/overall performance"
              className="navigation_wrapper navigation-button"
            >
              <div className="navigation_tab">
                <div className="menu_image_wrapper">
                  <svg
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.62838 13.8485L2.62824 13.8486C2.47083 14.0037 2.25827 14.09 2.03756 14.09C1.81685 14.09 1.60429 14.0037 1.44689 13.8486C1.28933 13.6934 1.2 13.4819 1.2 13.2604C1.2 13.0389 1.28933 12.8274 1.44689 12.6722L5.729 8.45297C5.72915 8.45283 5.7293 8.45268 5.72945 8.45253C5.80722 8.37539 5.89945 8.31439 6.00073 8.27281C6.10221 8.23116 6.21089 8.20977 6.32055 8.20977C6.43021 8.20977 6.53889 8.23116 6.64037 8.27281L6.52645 8.55034L6.64037 8.27281C6.74172 8.31441 6.83401 8.37547 6.91181 8.45268C6.9119 8.45278 6.912 8.45288 6.9121 8.45297L8.99766 10.5127L12.9005 6.66716L12.1558 5.93739C12.1556 5.93725 12.1555 5.93711 12.1553 5.93697C12.0451 5.8296 11.9668 5.69372 11.9297 5.54421L12.2209 5.47204L11.9297 5.5442C11.8926 5.39446 11.8985 5.23747 11.9466 5.09093C11.9947 4.94441 12.083 4.81455 12.201 4.71552L12.3939 4.94532L12.201 4.71552C12.3185 4.61694 12.4609 4.55266 12.6123 4.52928L15.8202 4.00249C15.8207 4.0024 15.8213 4.00232 15.8218 4.00223C15.9523 3.97979 16.0863 3.98841 16.2129 4.02742C16.3399 4.06659 16.456 4.13535 16.5512 4.22832C16.6464 4.32131 16.7179 4.43581 16.7593 4.56238C16.8007 4.68889 16.8107 4.82348 16.7884 4.95473L2.62838 13.8485ZM2.62838 13.8485L6.32045 10.2057L8.40418 12.2636C8.48188 12.3434 8.57482 12.4067 8.67737 12.4501C8.78116 12.494 8.89278 12.5166 9.00545 12.5166C9.11812 12.5166 9.22973 12.494 9.33353 12.4501C9.43604 12.4067 9.52896 12.3434 9.60664 12.2636L14.0991 7.8322L14.8467 8.57296L14.8467 8.57298L14.8494 8.5756C14.9577 8.68021 15.0923 8.75348 15.2387 8.78811C15.3851 8.82273 15.5383 8.81753 15.682 8.77302L15.682 8.77303L15.684 8.77237C15.8296 8.72613 15.9601 8.64104 16.0606 8.52589C16.1611 8.41087 16.2279 8.27034 16.2531 8.11958C16.2531 8.11937 16.2532 8.11916 16.2532 8.11896L16.7884 4.95497L2.62838 13.8485Z"
                      fill="#A8B1C1"
                    />
                  </svg>
                </div>
                <p>Performance</p>
              </div>
            </Link>

            {getDecodedToken()?.user_type !== "employee" && (
              <>
                <Link
                  className="navigation_wrapper navigation-button"
                  to="/settings"
                  state={{
                    from:
                      SettingsStore?.settingsOptionsArr[0]?.key ||
                      "notification_settings",
                  }}
                >
                  <div className="navigation_tab">
                    <div className="settings_img_wrapper menu_image_wrapper">
                      <svg
                        width="20"
                        height="19"
                        viewBox="0 0 20 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          id="path1"
                          d="M19.0572 9.29556V9.29164C19.0419 8.79856 18.9668 8.33259 18.8453 7.97535C18.6363 7.3621 18.3228 7.16846 18.0616 7.12634L16.489 6.55097L15.9698 5.77935L15.9596 5.76466L15.5247 4.92153L15.7771 3.26693C15.8675 3.01778 15.848 2.65042 15.4133 2.17367C15.1586 1.89415 14.7854 1.6032 14.3592 1.35144L14.2812 1.30703C13.6627 0.96579 13.0612 0.770844 12.6266 0.770844C12.2452 0.770844 12.0307 0.921053 11.9144 1.05755L10.6118 2.11914L9.81377 2.16485C9.75989 2.16779 9.7132 2.17041 9.67205 2.17367L8.7179 2.11914L7.41989 1.05526C7.30364 0.918441 7.08878 0.767578 6.70607 0.767578C6.27144 0.767578 5.67093 0.961544 5.05278 1.30115L5.04952 1.30278L4.97801 1.3436L4.97441 1.34556C4.54632 1.59667 4.1734 1.88697 3.91739 2.16616C3.48244 2.64161 3.46219 3.00929 3.55297 3.25877L3.80278 4.91336L3.36652 5.75551C3.29174 5.86621 2.99263 6.30868 2.83458 6.54183L1.26162 7.11524C1.00039 7.15573 0.686583 7.34904 0.477923 7.96131C0.355469 8.31822 0.279711 8.78452 0.263384 9.2776L0.261752 9.36838C0.260119 9.86244 0.319223 10.3314 0.428941 10.6932C0.616377 11.3116 0.922347 11.5167 1.18325 11.5663L2.73401 12.1949L3.23623 12.9999L3.64147 13.8574L3.33223 15.5018C3.23427 15.7477 3.23982 16.1157 3.65877 16.6072C3.90368 16.8952 4.2668 17.1989 4.68379 17.4653L4.76053 17.5127H4.76216C5.39435 17.8905 6.00661 18.1067 6.44679 18.1067C6.79783 18.1067 7.00355 17.9698 7.11849 17.8454L8.45111 16.8292L9.41964 16.8073L10.8564 16.8322L12.189 17.8493C12.3043 17.9757 12.5104 18.1132 12.8627 18.1132C13.3026 18.1132 13.9142 17.898 14.546 17.5218L14.6241 17.4735C15.0414 17.208 15.4045 16.905 15.6501 16.6173C16.069 16.1275 16.0765 15.7585 15.9766 15.5123L15.6697 13.8672L16.0703 13.0257L16.0778 13.0097L16.582 12.2064L18.1338 11.5797C18.395 11.5307 18.7006 11.3263 18.889 10.7092C18.9994 10.347 19.0595 9.87713 19.0585 9.38177L19.0572 9.29556Z"
                          fill="#A8B1C1"
                        />
                        <path
                          id="path2"
                          d="M9.57014 5.72656C8.81922 5.72656 8.08517 5.94924 7.46081 6.36642C6.83644 6.78361 6.34981 7.37657 6.06245 8.07033C5.77508 8.76408 5.6999 9.52747 5.84639 10.264C5.99289 11.0005 6.35449 11.677 6.88547 12.2079C7.41644 12.7389 8.09295 13.1005 8.82944 13.247C9.56593 13.3935 10.3293 13.3183 11.0231 13.031C11.7168 12.7436 12.3098 12.257 12.727 11.6326C13.1442 11.0082 13.3668 10.2742 13.3668 9.52326C13.3657 8.51666 12.9653 7.55161 12.2536 6.83983C11.5418 6.12806 10.5767 5.72769 9.57014 5.72656Z"
                          fill="#DCE0E6"
                        />
                      </svg>
                    </div>
                    <p>Settings</p>
                  </div>
                </Link>
              </>
            )}
          </div>
          <div className="footer_cards_container">
            <Link className="card footer_btn_animation" to="/connect">
              <div className="support_icon_text_wrappper">
                <div>
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.57999 18.7926L5.26371 18.7684L5.31407 19.0815C5.48436 20.1407 5.98301 21.1274 6.74975 21.8958L6.92672 21.7192L6.74976 21.8958C7.71086 22.8589 9.01455 23.4001 10.374 23.4001H10.9207H11.2202L11.1667 23.1054C11.1456 22.9893 11.1345 22.8693 11.1345 22.7465C11.1345 22.6254 11.1455 22.5054 11.167 22.3878L11.2207 22.093H10.921H10.374C9.36111 22.093 8.3896 21.6898 7.67319 20.9719C7.13355 20.4311 6.77196 19.7451 6.6264 19.0054L6.58427 18.7913L6.36645 18.8041C6.09011 18.8203 5.81228 18.8104 5.57999 18.7926ZM6.98668 18.3884L7.00263 18.3828L7.01769 18.3752C7.324 18.2197 7.53449 17.901 7.53449 17.533V10.7127C7.53449 7.13286 10.4303 4.2317 14.0014 4.2317C17.5725 4.2317 20.4683 7.13286 20.4683 10.7127V17.533C20.4683 18.0536 20.8897 18.4766 21.4105 18.4766H22.3323C23.2272 18.4766 24.0854 18.1204 24.718 17.4864C25.3507 16.8524 25.706 15.9927 25.706 15.0964V13.1888C25.706 12.2925 25.3507 11.4328 24.718 10.7989C24.0901 10.1696 23.24 9.8139 22.3522 9.80865C21.9022 5.58629 18.3356 2.29688 14.0014 2.29688C9.66721 2.29688 6.10064 5.58629 5.65059 9.80865C4.76287 9.8139 3.91273 10.1696 3.2848 10.7989C2.65218 11.4328 2.29688 12.2925 2.29688 13.1888V15.0964C2.29688 15.9927 2.65217 16.8524 3.28479 17.4864C3.78364 17.9863 4.42273 18.3135 5.10957 18.4296C5.19879 18.4447 5.49341 18.4928 5.84763 18.5091C6.19547 18.5251 6.63018 18.5123 6.98668 18.3884ZM16.5629 22.7465C16.5629 21.8155 15.8096 21.0598 14.8792 21.0598H13.1236C12.6769 21.0598 12.2486 21.2377 11.9329 21.554C11.6172 21.8704 11.4399 22.2994 11.4399 22.7465C11.4399 23.6776 12.1933 24.4332 13.1236 24.4332H14.8792C15.8096 24.4332 16.5629 23.6776 16.5629 22.7465Z"
                      fill="#A8B1C1"
                      stroke="#A8B1C1"
                      stroke-width="0.5"
                    />
                  </svg>
                </div>
                <p>Connect</p>
              </div>
              <div className="support_sub_text">
                Connect with our support team
                <div>
                  <img src={fastForwardIcon} alt="" />
                </div>
              </div>
            </Link>
            <button
              className="card footer_btn_animation"
              onClick={handleFeedbackModal}
            >
              <div className="support_icon_text_wrappper">
                <div>
                  <svg
                    width="22"
                    height="25"
                    viewBox="0 0 22 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.75641 11.2026H0V23.1898H5.75641V11.2026Z"
                      fill="#A7B1C1"
                    />
                    <path
                      d="M18.1345 23.933C19.051 23.9169 19.8148 23.2979 19.9755 22.4216L21.6237 13.3126C21.6237 12.7498 21.479 12.2112 21.1815 11.785C19.9675 9.9922 16.1085 10.4344 14.2513 10.6434C13.9217 10.6917 13.6162 10.7158 13.3187 10.764C13.174 10.7962 12.9891 10.7479 12.8765 10.6434C12.7559 10.5389 12.6836 10.3781 12.6836 10.2093V2.22587C12.6836 1.27719 12.1369 0.738528 11.6706 0.577735C11.2123 0.400862 10.754 0.529496 10.3922 0.907361L6.87891 10.764L6.93518 23.2898C10.5209 24.0536 14.2915 24.2546 18.1345 23.933Z"
                      fill="#A8B1C1"
                    />
                  </svg>
                </div>
                <p>Feedback</p>
              </div>
              <div className="support_sub_text">
                Help us improve by giving us feedback
                <div>
                  <img src={fastForwardIcon} alt="" />
                </div>
              </div>
            </button>
            <div className="cards_bottom_navigation">
              <a
                href={`${process.env.REACT_APP_PRE_LOGIN_URL}/disclaimer/`}
                target="_blank"
                rel="noreferrer"
              >
                <p> Disclaimer</p>
              </a>
              <img src={whiteDot} alt="dot" />
              <a
                href={`${process.env.REACT_APP_PRE_LOGIN_URL}/privacy-policy/`}
                target="_blank"
                rel="noreferrer"
              >
                <p>Privacy Policy</p>
              </a>
              <img src={whiteDot} alt="dot" />
              <a
                href={`${process.env.REACT_APP_PRE_LOGIN_URL}/terms-conditions/`}
                target="_blank"
                rel="noreferrer"
              >
                <p>Terms and Conditions</p>
              </a>
            </div>
          </div>
        </div>
        <div className="copyright_container">
          © COPYRIGHT 2022 BY NUVAMA PRIVATE WEALTH MANAGEMENT. ALL RIGHTS
          RESERVED
        </div>
        <div className="copyright_container">{`${buildDetails}`}</div>
      </div>
      <Modal
        title="Feedback"
        width="650px"
        onClose={handleFeedbackModal}
        open={feedbackModal}
        modalStyle={{ overflow: "auto" }}
        submitted={submitted}
      >
        <FooterModal
          ref={modalRef}
          step={step}
          setStep={setStep}
          onClose={handleFeedbackModal}
          rangeValue={rangeValue}
          feedbackText={feedbackText}
          setFeedbackText={(data) => setFeedbackText(data)}
          setRangeValue={(data) => setRangeValue(data)}
          setSubmitted={(data) => setSubmitted(data)}
        />
      </Modal>
    </footer>
  );
});

export default Footer;
